module.exports = __webpack_public_path__ + "img/1.c398cd31.png";